/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IChronicCondition } from 'app/shared/model/chronic-condition.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { ClinicalStatus } from 'app/shared/model/enumerations/clinical-status.model';
import { VerificationStatus } from 'app/shared/model/enumerations/verification-status.model';
import { ConditionCategory } from 'app/shared/model/enumerations/condition-category.model';
import { ConditionSeverity } from 'app/shared/model/enumerations/condition-severity.model';

export interface IPatientCondition {
  id?: string;
  active?: boolean;
  microSec?: number;
  lastupdated?: number;
  timestampentry?: number;
  cursor?: number;
  startDate?: number;
  startObservations?: string | null;
  suspendedDate?: number | null;
  suspendedObservations?: string | null;
  suspended?: boolean;
  clinicalStatus?: keyof typeof ClinicalStatus | null;
  verificationStatus?: keyof typeof VerificationStatus | null;
  conditionCategory?: keyof typeof ConditionCategory | null;
  conditionSeverity?: keyof typeof ConditionSeverity | null;
  snomedBodySiteConceptId?: string;
  snomedBodySiteConceptText?: string;
  chronicCondition?: IChronicCondition;
  suspendedBy?: IDoctor | null;
  reportedBy?: IDoctor | null;
  patient?: IGlucoUser;
}

export const defaultValue: Readonly<IPatientCondition> = {
  active: false,
  suspended: false,
};
